import { render, staticRenderFns } from "./CompanyDesktopMultiRestaurantMeals.vue?vue&type=template&id=72a369ff"
import script from "./CompanyDesktopMultiRestaurantMeals.vue?vue&type=script&lang=js"
export * from "./CompanyDesktopMultiRestaurantMeals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports